import { render, staticRenderFns } from "./CustomFontSelect.vue?vue&type=template&id=0e5e5fd2&scoped=true&"
import script from "./CustomFontSelect.vue?vue&type=script&lang=js&"
export * from "./CustomFontSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomFontSelect.vue?vue&type=style&index=0&id=0e5e5fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5e5fd2",
  null
  
)

export default component.exports